








import { Component, Prop, Vue } from 'vue-property-decorator'

import { CourseSubjectLargeResource } from '@/store/types'

@Component
export default class HelpCard extends Vue {
  @Prop({ required: true })
  private subject!: CourseSubjectLargeResource
}
